import Vue from 'vue'
import Router from 'vue-router'
import index from '../view/index'
import regiest from '../view/regiest'
Vue.use(Router)

const routes = [
    {
        path:'/',
        component: regiest
    },
    {
        path: '/index',
        component: index
    }
]
export default new Router({
    routes
})